jQuery(function () {
	// Replace email input values with trimmed values
	$("input[type='email']").on("blur", function () {
		if ((<HTMLInputElement>this).value) {
			var trimmedEmailVal = (<HTMLInputElement>this).value.trim();
			(<HTMLInputElement>this).value = trimmedEmailVal;
		}
	});
	(<any>$('.fancybox')).fancybox({
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350,
		nextEffect: 'fade',
		nextSpeed: 200,
		loop: false
	});
	(<any>$('.iframe')).fancybox({
		type: 'iframe',
		maxWidth: 500,
		fitToView: false,
		width: '90%',
		autoSize: false,
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350
	});
	(<any>$('.inline')).fancybox({
		openEffect: 'elastic',
		openSpeed: 350,
		closeEffect: 'elastic',
		closeSpeed: 350,
		nextEffect: 'fade',
		nextSpeed: 200,
		scrolling: 'no',
		autoSize: true
	});
	(<any>$("#a_lightbox")).fancybox({ autoSize: true, scrolling: "no" });
});
//Fancybox Lightbox End
//dilogBox
//@Author: Adarsh Kurudi
function dilogBox(dialogObj: DialogObj): void {
	var template = {
		outerWrap: (dialogObj.pointsUnavailable)?'<div class="overlay" id="dialogbox" aria-label="Confirmation email lightbox" tabindex=0 role="dialog"><div class="confirmation points-unavailable-lightbox"></div></div>':'<div class="overlay" id="dialogbox" aria-label="Confirmation email lightbox" tabindex=0 role="dialog"><div class="confirmation email-lightbox"></div></div>',
		closeBtn: '<p><a href="javascript:void(0)" onClick="document.getElementById(\'dialogbox\').style.visibility = \'hidden\';document.getElementById(\'dialogbox\').style.display = \'none\';" class="icon-close" aria-label="Close lightbox"><span style="display:none;">Close</span></a></p>',
		innerMain: (dialogObj.pointsUnavailable)?'<div class="lb-content"><div class="lb-form"><p id="dialogMain"></p>':'<div class="lb-content"><div class="lb-form"><h3 id="dialogMain"></h3>',
		innerSecondary: '<p id="dialogSecondary"></p>',
		confirmBtn: '<button type="button" id="dialogBtn" onClick="document.getElementById(\'dialogbox\').style.visibility = \'hidden\';document.getElementById(\'dialogbox\').style.display = \'none\';" class="btn-main">Start Shopping</button></div></div>'
	};
	if (!document.getElementById('dialogbox')) {
		$(template.outerWrap).prependTo('body').trigger('focus');
	} else {
		document.getElementById('dialogbox').style.display = "";
		document.getElementById('dialogbox').style.visibility = "visible";
	}
	$('.confirmation').html(template.closeBtn + template.innerMain + template.innerSecondary + template.confirmBtn);
	$('#dialogMain').text(dialogObj.mainTxt);
	$('#dialogSecondary').text(dialogObj.secondaryTxt);
	$('#dialogBtn').val(dialogObj.btnTxt);
	$('#dialogbox').on('click', function () {
		$(this).css({
			'visibility': 'hidden',
			'display': 'none	'
		});
	});
}
//End dilogBox
$(function () {
	//Include for JQuery version 1.5 and below
	jQuery.expr.pseudos.focus = function (elem: any) {
		return elem === document.activeElement && (elem.type || elem.href);
	};
	$("form").on("keypress", function (e) {
		if (e.key === 'Enter') {
			//alert($("#tSearchString").is(":focus"));
			if ($("#tSearchString").is(":focus")) {
				$("#searchSubmit").trigger("click");
				return false;
			} else if ($("#sweepsName, #sweepsEmail, #sweepsCheck, #sweepsBonvoyCheck").is(":focus")) {
				$("#sweepsBtn").trigger("click");
				return false;
			} else if ($("#landingPageSweepsName, #landingPageSweepsEmail, #landingPageSweepsCheck, #landingPageSweepsBonvoyCheck, #recaptcha-anchor").is(":focus")) {
				$("#landingPageSweepsBtn").trigger("click");
				return false;
			} else if ($("#emailAddress1").is(":focus")) {
				$("#emailAddress1").trigger("blur");
				$("#emailAddress1btn").trigger("click");
				return false;
			} else if ($("#emailAddress2").is(":focus")) {
				$("#emailAddress2").trigger("blur");
				$("#emailAddress2btn").trigger("click");
				return false;
			} else if ($("#searchUI_tbProductName").is(":focus")) {
				doSearch();
				return false;
			} else if ($("#validationNbr").is(":focus")) {
				$("#validationNbr").trigger("blur");
				$("#btn_apply").trigger("click");
				return false;
			}
		}
	});
});

// On "DOMContentLoaded" (before the "load" event), calls "HAHAccessibility.init()" 
$(() => HAHAccessibility.init())